<template>
    <div class="user_auth">
        <form class="user">
            <div class="form-group">
                <b-form-input  :state="username_state" id="input-live-feedback" v-model="user_form.username" class="form-control form-control-user" placeholder="USER"></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback">
                    Минимум 3 символа
                </b-form-invalid-feedback>

            </div>
            <div class="form-group">
                <b-form-input   :state="userpass_state" id="user_pass" type="password" v-model="user_form.password" class="form-control form-control-user" placeholder="Password"></b-form-input>

                <b-form-invalid-feedback id="user_pass">
                    Минимум 6 символов
                </b-form-invalid-feedback>

            </div>
            <div class="form-group">
                <b-button :disabled="!is_disabled" class="btn btn-warning btn-user btn-block" v-on:click="make_auth">Вход</b-button>
            </div>
        </form>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                is_auth : false,
                user_form : {
                    username : "",
                    password : "",
                    api_auth : true,
                }
            }
        },

        created() {
            console.log("OK");
        },

        methods: {
            async make_auth () {
                await axios_api.post('/api_auth', qs.stringify(this.user_form)).then(({data}) => {
                    console.log(data);
                    if (data.status === "operation_success") {
                        window.location.reload();
                    }
                    else {
                        EventBus.$emit('show_toast', {err: "Ошибка Авторизации", type: "danger", title: "Нет"})
                    }
                }).catch((err) => {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                })
            },
        },

        computed : {

            is_disabled () {
                return this.username_state && this.userpass_state;
            },

            username_state() {
                return this.user_form.username.length > 2;
            },

            userpass_state () {
                return this.user_form.password.length > 5;
            }

        }

    }
</script>

<style scoped>

</style>
